import type { AnchorHTMLAttributes } from 'react';
import { resolveButtonClassName, type ButtonLook } from '../Button/button-classes';
import styles from '../Button/Button.module.scss';

interface LinkButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement>, Partial<ButtonLook> {}

/** A link drawn exactly like a `Button`, for an action that navigates. */
export function LinkButton({
  variant = 'primary',
  size = 'medium',
  shape = 'rectangle',
  prominent = false,
  className,
  children,
  ...anchorProps
}: LinkButtonProps): JSX.Element {
  return (
    <a className={resolveButtonClassName({ variant, size, shape, prominent }, className)} {...anchorProps}>
      <span className={styles.content}>{children}</span>
    </a>
  );
}
